export default __webpack_public_path__ + "static/be-eb2ac250c9e9c61456397ebee295b067.svg";